module.exports = __webpack_public_path__ + "img/DownloadEss.a784a8f4.svg";